module.exports = __webpack_public_path__ + "img/ws-3.4091915e.jpg";